module.exports = __webpack_public_path__ + "static/media/12.64cc1b8e.png";